import React from 'react';
import data from '../../data/volunteers.json';
import NetworkBackground from '../../components/elements/NetworkBackground';

export default function VolunteersMain() {

    return (
        <div className="vol-main">
            <NetworkBackground />
            <style>{`
                .vol-main {
                    background: var(--eventflow-black);
                    position: relative;
                }
                .vol-main::before {
                    content: '';
                    position: fixed; inset: 0;
                    background-image:
                        linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px);
                    background-size: 60px 60px;
                    pointer-events: none;
                    z-index: 0;
                }

                /* shared section wrapper */
                .vol-sec {
                    padding: 80px 0;
                    position: relative; overflow: hidden;
                    border-top: 1px solid rgba(255,255,255,0.05);
                    z-index: 1;
                }
                .vol-sec-tag {
                    display: inline-flex; align-items: center; gap: 8px;
                    font-family: var(--eventflow-font);
                    font-size: 11px; font-weight: 700;
                    letter-spacing: 3px; text-transform: uppercase;
                    color: var(--eventflow-base); margin-bottom: 12px;
                }
                .vol-sec-tag::before, .vol-sec-tag::after {
                    content: ''; display: inline-block;
                    width: 24px; height: 1px;
                    background: var(--eventflow-base); opacity: 0.5;
                }
                .vol-sec-title {
                    font-family: var(--eventflow-font);
                    font-size: 38px; font-weight: 900;
                    color: #fff; letter-spacing: -1px; margin-bottom: 12px;
                }
                .vol-sec-title span { color: var(--eventflow-base); }
                .vol-sec-sub {
                    font-family: var(--eventflow-font);
                    font-size: 15px; color: rgba(255,255,255,0.45);
                    max-width: 560px; line-height: 1.75;
                }

                /* ── Intro ── */
                .vol-intro-box {
                    background: rgba(var(--eventflow-primary-rgb),0.05);
                    border: 1px solid rgba(var(--eventflow-primary-rgb),0.15);
                    border-radius: 16px; padding: 32px 36px;
                    font-family: var(--eventflow-font);
                    font-size: 15px; color: rgba(255,255,255,0.65);
                    line-height: 1.8;
                }
                .vol-intro-box strong { color: #fff; }

                /* ── Roles grid ── */
                .vol-roles-grid {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 16px; margin-top: 40px;
                }
                .vol-role-card {
                    background: rgba(255,255,255,0.03);
                    border: 1px solid rgba(255,255,255,0.07);
                    border-radius: 14px; padding: 24px 20px;
                    transition: all 0.3s;
                }
                .vol-role-card:hover {
                    border-color: rgba(var(--eventflow-base-rgb),0.3);
                    transform: translateY(-4px);
                    box-shadow: 0 16px 40px rgba(0,0,0,0.3);
                }
                .vol-role-icon {
                    width: 48px; height: 48px; border-radius: 12px;
                    background: rgba(var(--eventflow-base-rgb),0.1);
                    display: flex; align-items: center; justify-content: center;
                    margin-bottom: 14px; transition: background 0.3s;
                }
                .vol-role-card:hover .vol-role-icon { background: rgba(var(--eventflow-base-rgb),0.2); }
                .vol-role-icon i { font-size: 20px; color: var(--eventflow-base); }
                .vol-role-title {
                    font-family: var(--eventflow-font);
                    font-size: 14px; font-weight: 700; color: #fff; margin-bottom: 8px;
                }
                .vol-role-desc {
                    font-family: var(--eventflow-font);
                    font-size: 12px; color: rgba(255,255,255,0.4); line-height: 1.6; margin: 0;
                }

                /* ── Benefits ── */
                .vol-benefits-grid {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 16px; margin-top: 40px;
                }
                .vol-benefit {
                    display: flex; align-items: flex-start; gap: 14px;
                    background: rgba(255,255,255,0.03);
                    border: 1px solid rgba(255,255,255,0.07);
                    border-radius: 12px; padding: 20px;
                    transition: border-color 0.3s;
                }
                .vol-benefit:hover { border-color: rgba(var(--eventflow-base-rgb),0.25); }
                .vol-benefit__icon {
                    width: 40px; height: 40px; border-radius: 10px;
                    background: rgba(var(--eventflow-base-rgb),0.1);
                    display: flex; align-items: center; justify-content: center;
                    flex-shrink: 0;
                }
                .vol-benefit__icon i { font-size: 16px; color: var(--eventflow-base); }
                .vol-benefit__title {
                    font-family: var(--eventflow-font);
                    font-size: 14px; font-weight: 700; color: #fff; margin-bottom: 4px;
                }
                .vol-benefit__desc {
                    font-family: var(--eventflow-font);
                    font-size: 12px; color: rgba(255,255,255,0.4); line-height: 1.6; margin: 0;
                }

                /* ── Eligibility ── */
                .vol-elig-list {
                    display: flex; flex-direction: column; gap: 10px; margin-top: 32px;
                    max-width: 700px;
                }
                .vol-elig-item {
                    display: flex; align-items: flex-start; gap: 12px;
                    font-family: var(--eventflow-font);
                    font-size: 14px; color: rgba(255,255,255,0.65); line-height: 1.5;
                }
                .vol-elig-item i { color: var(--eventflow-base); font-size: 13px; margin-top: 2px; flex-shrink: 0; }

                /* ── Guidelines ── */
                .vol-guide-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 16px; margin-top: 32px;
                }
                .vol-guide-card {
                    background: rgba(255,255,255,0.03);
                    border: 1px solid rgba(255,255,255,0.07);
                    border-radius: 12px; padding: 22px 24px;
                }
                .vol-guide-title {
                    font-family: var(--eventflow-font);
                    font-size: 14px; font-weight: 700; color: #fff; margin-bottom: 8px;
                    display: flex; align-items: center; gap: 8px;
                }
                .vol-guide-title::before {
                    content: '';
                    width: 4px; height: 16px; border-radius: 2px;
                    background: var(--eventflow-base); flex-shrink: 0;
                }
                .vol-guide-desc {
                    font-family: var(--eventflow-font);
                    font-size: 13px; color: rgba(255,255,255,0.45); line-height: 1.65; margin: 0;
                }

                /* ── Timeline ── */
                .vol-timeline { margin-top: 32px; position: relative; }
                .vol-timeline::before {
                    content: '';
                    position: absolute; left: 20px; top: 0; bottom: 0;
                    width: 1px; background: rgba(255,255,255,0.07);
                }
                .vol-tl-item {
                    display: flex; gap: 20px; margin-bottom: 24px;
                    position: relative;
                }
                .vol-tl-dot {
                    width: 40px; height: 40px; border-radius: 50%;
                    background: rgba(var(--eventflow-base-rgb),0.1);
                    border: 2px solid rgba(var(--eventflow-base-rgb),0.3);
                    display: flex; align-items: center; justify-content: center;
                    flex-shrink: 0; position: relative; z-index: 1;
                    font-family: 'Courier New', monospace;
                    font-size: 11px; font-weight: 700; color: var(--eventflow-base);
                }
                .vol-tl-content {
                    background: rgba(255,255,255,0.03);
                    border: 1px solid rgba(255,255,255,0.07);
                    border-radius: 12px; padding: 18px 22px; flex: 1;
                }
                .vol-tl-date {
                    font-family: var(--eventflow-font);
                    font-size: 11px; font-weight: 700;
                    letter-spacing: 1.5px; text-transform: uppercase;
                    color: var(--eventflow-base); margin-bottom: 4px;
                }
                .vol-tl-title {
                    font-family: var(--eventflow-font);
                    font-size: 15px; font-weight: 700; color: #fff; margin-bottom: 6px;
                }
                .vol-tl-desc {
                    font-family: var(--eventflow-font);
                    font-size: 13px; color: rgba(255,255,255,0.45); line-height: 1.6; margin: 0;
                }

                /* ── Application Form ── */
                .vol-form-wrap {
                    display: grid; grid-template-columns: 1fr 480px;
                    gap: 56px; align-items: start;
                }
                .vol-form-card {
                    background: rgba(255,255,255,0.03);
                    border: 1px solid rgba(255,255,255,0.08);
                    border-radius: 16px; overflow: hidden;
                }
                .vol-form-card__header {
                    background: rgba(255,255,255,0.04);
                    border-bottom: 1px solid rgba(255,255,255,0.06);
                    padding: 20px 28px;
                }
                .vol-form-card__header h3 {
                    font-family: var(--eventflow-font);
                    font-size: 20px; font-weight: 800; color: #fff; margin: 0 0 4px;
                }
                .vol-form-card__header p {
                    font-size: 13px; color: rgba(255,255,255,0.4); margin: 0;
                }
                .vol-form-card__body { padding: 28px; }
                .vol-field { display: flex; flex-direction: column; gap: 6px; margin-bottom: 14px; }
                .vol-field label {
                    font-family: var(--eventflow-font);
                    font-size: 11px; font-weight: 700;
                    letter-spacing: 1.5px; text-transform: uppercase;
                    color: rgba(255,255,255,0.4);
                }
                .vol-field input, .vol-field select, .vol-field textarea {
                    background: rgba(255,255,255,0.05);
                    border: 1px solid rgba(255,255,255,0.1);
                    border-radius: 8px; padding: 11px 14px;
                    font-family: var(--eventflow-font);
                    font-size: 14px; color: #fff; outline: none; width: 100%;
                    transition: border-color 0.3s;
                }
                .vol-field input::placeholder, .vol-field textarea::placeholder { color: rgba(255,255,255,0.25); }
                .vol-field input:focus, .vol-field select:focus, .vol-field textarea:focus { border-color: rgba(var(--eventflow-base-rgb),0.5); }
                .vol-field select option { background: #0d0010; color: #fff; }
                .vol-field textarea { resize: vertical; min-height: 100px; }
                .vol-form-submit .thm-btn {
                    width: 100%; justify-content: center;
                    border-radius: 10px !important; padding: 14px 24px !important; font-size: 15px !important;
                }
                .vol-success {
                    text-align: center; padding: 48px 24px;
                }
                .vol-success__icon {
                    width: 72px; height: 72px; border-radius: 50%;
                    background: rgba(var(--eventflow-base-rgb),0.1);
                    border: 2px solid rgba(var(--eventflow-base-rgb),0.3);
                    display: flex; align-items: center; justify-content: center;
                    margin: 0 auto 20px;
                }
                .vol-success__icon i { font-size: 30px; color: var(--eventflow-base); }
                .vol-success h4 { font-family: var(--eventflow-font); font-size: 22px; font-weight: 800; color: #fff; margin-bottom: 10px; }
                .vol-success p { font-size: 14px; color: rgba(255,255,255,0.45); line-height: 1.7; margin: 0; }

                /* ── CTA ── */
                .vol-cta-box {
                    background: rgba(var(--eventflow-base-rgb),0.05);
                    border: 1px solid rgba(var(--eventflow-base-rgb),0.15);
                    border-radius: 20px; padding: 56px 48px;
                    text-align: center; position: relative; overflow: hidden;
                }
                .vol-cta-box::before {
                    content: '';
                    position: absolute; top: 0; left: 10%; right: 10%; height: 2px;
                    background: linear-gradient(90deg, transparent, var(--eventflow-base), var(--eventflow-primary), transparent);
                }
                .vol-cta-box h2 {
                    font-family: var(--eventflow-font);
                    font-size: 38px; font-weight: 900; color: #fff;
                    letter-spacing: -1px; margin-bottom: 12px;
                }
                .vol-cta-box p {
                    font-size: 15px; color: rgba(255,255,255,0.45);
                    max-width: 500px; margin: 0 auto 28px; line-height: 1.75;
                }
                .vol-cta-note {
                    font-size: 12px; color: rgba(255,255,255,0.25); margin-top: 16px;
                }

                @media (max-width: 1199px) { .vol-form-wrap { grid-template-columns: 1fr 420px; gap: 40px; } }
                @media (max-width: 991px) {
                    .vol-roles-grid { grid-template-columns: repeat(2,1fr); }
                    .vol-benefits-grid { grid-template-columns: repeat(2,1fr); }
                    .vol-form-wrap { grid-template-columns: 1fr; }
                    .vol-guide-grid { grid-template-columns: 1fr; }
                    .vol-sec-title { font-size: 30px; }
                }
                @media (max-width: 576px) {
                    .vol-roles-grid { grid-template-columns: 1fr; }
                    .vol-benefits-grid { grid-template-columns: 1fr; }
                    .vol-cta-box { padding: 36px 20px; }
                    .vol-cta-box h2 { font-size: 26px; }
                    .vol-form-card__body { padding: 20px; }
                }
            `}</style>

            {/* ── Intro ── */}
            <section className="vol-sec">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-5 wow fadeInLeft" data-wow-delay="100ms">
                            <div className="vol-sec-tag">{data.intro.tag}</div>
                            <h2 className="vol-sec-title">{data.intro.heading}</h2>
                        </div>
                        <div className="col-lg-7 wow fadeInRight" data-wow-delay="200ms">
                            <div className="vol-intro-box">{data.intro.body}</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── Roles ── */}
            <section className="vol-sec">
                <div className="container">
                    <div className="text-center wow fadeInUp" data-wow-delay="100ms">
                        <div className="vol-sec-tag" style={{justifyContent:'center'}}>{data.rolesSection.tag}</div>
                        <h2 className="vol-sec-title" style={{textAlign:'center'}}>{data.rolesSection.title} <span>{data.rolesSection.titleAccent}</span></h2>
                        <p className="vol-sec-sub" style={{margin:'0 auto'}}>{data.rolesSection.subtitle}</p>
                    </div>
                    <div className="vol-roles-grid wow fadeInUp" data-wow-delay="150ms">
                        {data.roles.map((r, i) => (
                            <div className="vol-role-card" key={i}>
                                <div className="vol-role-icon"><i className={`fa ${r.icon}`} /></div>
                                <div className="vol-role-title">{r.title}</div>
                                <p className="vol-role-desc">{r.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── Benefits ── */}
            <section className="vol-sec">
                <div className="container">
                    <div className="text-center wow fadeInUp" data-wow-delay="100ms">
                        <div className="vol-sec-tag" style={{justifyContent:'center'}}>{data.benefitsSection.tag}</div>
                        <h2 className="vol-sec-title" style={{textAlign:'center'}}>{data.benefitsSection.title} <span>{data.benefitsSection.titleAccent}</span></h2>
                        <p className="vol-sec-sub" style={{margin:'0 auto'}}>{data.benefitsSection.subtitle}</p>
                    </div>
                    <div className="vol-benefits-grid wow fadeInUp" data-wow-delay="150ms">
                        {data.benefits.map((b, i) => (
                            <div className="vol-benefit" key={i}>
                                <div className="vol-benefit__icon"><i className={`fa ${b.icon}`} /></div>
                                <div>
                                    <div className="vol-benefit__title">{b.title}</div>
                                    <p className="vol-benefit__desc">{b.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── Eligibility + Guidelines ── */}
            <section className="vol-sec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 wow fadeInLeft" data-wow-delay="100ms">
                            <div className="vol-sec-tag">{data.eligibilitySection.tag}</div>
                            <h2 className="vol-sec-title">{data.eligibilitySection.title} <span>{data.eligibilitySection.titleAccent}</span></h2>
                            <div className="vol-elig-list">
                                {data.eligibility.map((e, i) => (
                                    <div className="vol-elig-item" key={i}>
                                        <i className="fa fa-check-circle" />
                                        {e}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-lg-6 wow fadeInRight" data-wow-delay="200ms">
                            <div className="vol-sec-tag">{data.guidelinesSection.tag}</div>
                            <h2 className="vol-sec-title">{data.guidelinesSection.title} <span>{data.guidelinesSection.titleAccent}</span></h2>
                            <div className="vol-guide-grid">
                                {data.guidelines.map((g, i) => (
                                    <div className="vol-guide-card" key={i}>
                                        <div className="vol-guide-title">{g.title}</div>
                                        <p className="vol-guide-desc">{g.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── Timeline ── */}
            <section className="vol-sec">
                <div className="container">
                    <div className="text-center mb-5 wow fadeInUp" data-wow-delay="100ms">
                        <div className="vol-sec-tag" style={{justifyContent:'center'}}>{data.timelineSection.tag}</div>
                        <h2 className="vol-sec-title" style={{textAlign:'center'}}>{data.timelineSection.title} <span>{data.timelineSection.titleAccent}</span></h2>
                    </div>
                    <div className="vol-timeline wow fadeInUp" data-wow-delay="150ms" style={{maxWidth:'700px',margin:'0 auto'}}>
                        {data.timeline.map((t, i) => (
                            <div className="vol-tl-item" key={i}>
                                <div className="vol-tl-dot">{String(i+1).padStart(2,'0')}</div>
                                <div className="vol-tl-content">
                                    <div className="vol-tl-date">{t.date} · {t.time}</div>
                                    <div className="vol-tl-title">{t.title}</div>
                                    <p className="vol-tl-desc">{t.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── Apply CTA ── */}
            <section className="vol-sec" id="apply">
                <div className="container">
                    <div className="vol-cta-box wow fadeInUp" data-wow-delay="100ms" style={{maxWidth:'700px',margin:'0 auto'}}>
                        <h2>{data.cta.title}</h2>
                        <p>{data.cta.subtitle}</p>
                        <a href={data.cta.buttonLink} className="thm-btn" target="_blank" rel="noopener noreferrer">
                            {data.cta.buttonText} <span className="icon-arrow-right" />
                        </a>
                        <p className="vol-cta-note">{data.cta.note}</p>
                    </div>
                </div>
            </section>
        </div>
    );
}
